var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "2723fdf8-22cd-4a3e-a5e2-3dd7646800c4",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02f9f2c1-c5f9-4dfd-bbb7-918d15e8e05e",
    "data-name": "map pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,1a8.6,8.6,0,0,0-8.6,8.6c0,4.35,7.2,12.05,8.42,13.33a0.24,0.24,0,0,0,.35,0c1.22-1.27,8.42-9,8.42-13.33A8.6,8.6,0,0,0,11.9,1Zm0,11.67A3.07,3.07,0,1,1,15,9.6,3.07,3.07,0,0,1,11.9,12.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.640eba81dae73d56b7925b7188dfbaee.svg";
export { ForwardRef as ReactComponent };